module.exports = __webpack_public_path__ + "static/media/perkins-will.066c010c.png";